import { AiChat } from '@/assets/icons'
import { Button } from '@/components/button/Button'
import { IconButton } from '@/components/icon-button/IconButton'
import { useStartMedChronAssetChat } from '../hooks/useStartMedChronAssetChat'

interface MedChronAssetChatButtonProps {
  assetId: string
  matterId: string
  compact?: boolean
}

/**
 * Starts a new assistant chat grounded in the matter's living Medical Chronology.
 */
export default function MedChronAssetChatButton(props: MedChronAssetChatButtonProps) {
  const { assetId, matterId, compact = false } = props
  const { isLoading, startChat } = useStartMedChronAssetChat({ assetId, matterId })

  if (compact) {
    return (
      <IconButton
        onClick={() => startChat()}
        disabled={isLoading}
        loading={isLoading}
        variant="plain"
        color="primary"
        size="lg"
        icon={<AiChat />}
        aria-label="Chat with the Medical Chronology"
      />
    )
  }

  return (
    <Button
      onClick={() => startChat()}
      disabled={isLoading}
      loading={isLoading}
      variant="outlined"
      color="primary"
      size="sm"
      leadingIcon={<AiChat />}
      aria-label="Chat with the Medical Chronology"
    >
      Ask Assistant
    </Button>
  )
}
